module.exports = "data:text/markdown;base64,IyMjIFRhbGsgVGltZToKVG90YWwgdGltZSBzcGVudCBvbiB0aGUgdGFsa2luZyB3aXRoIHByb3NwZWN0cy4K"